import React, { useEffect, useState } from "react";
import "./WithTheHelpOf.css";

const WithTheHelpOf = ({ page }) => {
  const [cardContent, setCardContent] = useState([]);

  useEffect(() => {
    switch (page) {
      case "education": {
        setCardContent([
          "your custom virtual campus",
          "teach unlimited classrooms",
          "stronger community bonds",
          "video & text communication",
          "easy access on web & mobile",
        ]);
        break;
      }

      case "office": {
        setCardContent([
          "your custom virtual office",
          "host unlimited meetings",
          "build shared culture",
          "video & text communication",
          "easy access on web & mobile",
        ]);
        break;
      }

      case "community": {
        setCardContent([
          "your custom virtual campus",
          "teach unlimited classrooms",
          "stronger community bonds",
          "video & text communication",
          "easy access on web & mobile",
        ]);
        break;
      }

      case "event": {
        setCardContent([
          "your custom virtual campus",
          "teach unlimited classrooms",
          "stronger community bonds",
          "video & text communication",
          "easy access on web & mobile",
        ]);
        break;
      }

      case "revirtclub": {
        setCardContent([
          "your own social adda",
          "organize unlimited events",
          "customize your working space",
          "regular reminders for upcoming events",
          "learning & internship oppurtunities"
        ])
      }

      default:
        break;
    }
  }, []);

  return (
    <div className="section withthehelpofOuterContainer">
      <div className="container">
        <div className="row justify-content-center">
          <p>with the help of following features</p>
          {cardContent.map((card, i) => {
            return (
              <div className="col-xl-2 col-lg-12 col-md-12 col-sm-12 col-12 withthehelpofcol" key={i}>
                <div>
                    <p>
                        {card}
                    </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default WithTheHelpOf;
